export default "__VITE_ASSET__D_r4KJtm__"